import { Linking, View } from 'react-native'
import { Text, TextDescriptionVariant } from '@pff-consumer/tweed-ui/atoms/browser-text'
import { useTheme } from '@pff-consumer/tweed-ui/styles/theme'
import { useStyles } from './missing-espn-secrets-error.styles'

export const MissingEspnSecretsError = () => {
  const theme = useTheme()
  const styles = useStyles()

  return (
    <View
      style={styles.espnContainer}
      testID='fantasy.missing.espnSecrets'
    >
      <Text
        variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        colorOverride={theme.colors.webModalDescriptionColor}
        textAlign='center'
      >
        We could not connect to ESPN.
      </Text>
      <Text
        variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        colorOverride={theme.colors.webModalDescriptionColor}
        textAlign='center'
      >
        Please follow the instructions in Step 2 to install the PFF Chrome Extension.
      </Text>
      <Text
        variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        colorOverride={theme.colors.webModalDescriptionColor}
        textAlign='center'
      >
        In a new tab, navigate to your ESPN Fantasy League Page at{' '}
        <Text
          variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
          colorOverride={theme.colors.webButtonBackground}
          onPress={() => Linking.openURL('https://www.espn.com/fantasy')}
        >
          https://www.espn.com/fantasy
        </Text>
        .
      </Text>
      <Text
        variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        colorOverride={theme.colors.webModalDescriptionColor}
        textAlign='center'
      >
        Open the PFF Chrome Extension. Please allow authorization to sync your fantasy leagues with your PFF account.
      </Text>
      <Text
        variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        colorOverride={theme.colors.webModalDescriptionColor}
        textAlign='center'
      >
        You need to have the PFF Chrome Extension open on both PFF and ESPN at the same time.
      </Text>
    </View>
  )
}
